import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';

const PresenceModal = ({ open, onOpenChange, employee, onSubmit, initialData }) => {
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [status, setStatus] = useState('Présent');
  const [hours, setHours] = useState('8');
  const [notes, setNotes] = useState('');

  React.useEffect(() => {
    if (open) {
      if (initialData) {
        // Simple mapping for demonstration. Real date parsing needed for real backend data.
        setDate(initialData.rawDate || new Date().toISOString().split('T')[0]);
        setStatus(initialData.status === 'En attente' ? 'Présent' : initialData.status);
      } else {
        setDate(new Date().toISOString().split('T')[0]);
        setStatus('Présent');
        setHours('8');
        setNotes('');
      }
    }
  }, [open, initialData]);

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit({
        id: initialData?.id,
        employee_id: employee?.id,
        date,
        status,
        hours: parseFloat(hours),
        notes
      });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Gérer la présence</DialogTitle>
          <DialogDescription className="sr-only">Modal pour gérer la présence</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <label className="text-right text-sm font-medium">Date</label>
            <Input 
              type="date" 
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="col-span-3"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <label className="text-right text-sm font-medium">Statut</label>
            <div className="col-span-3">
              <Select value={status} onValueChange={setStatus}>
                <SelectTrigger>
                  <SelectValue placeholder="Sélectionnez un statut" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Présent">Présent</SelectItem>
                  <SelectItem value="Absent">Absent (Injustifié)</SelectItem>
                  <SelectItem value="Congé payé">Congé payé</SelectItem>
                  <SelectItem value="Maladie">Maladie</SelectItem>
                  <SelectItem value="Retard">Retard</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <label className="text-right text-sm font-medium">Heures</label>
            <Input 
              type="number" 
              value={hours}
              onChange={(e) => setHours(e.target.value)}
              className="col-span-3"
              min="0"
              max="24"
              step="0.5"
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <label className="text-right text-sm font-medium">Notes</label>
            <Input 
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Observation (optionnel)"
              className="col-span-3"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button onClick={handleSubmit} className="bg-violet-600 hover:bg-violet-700 text-white">Enregistrer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PresenceModal;
